<card-result-item [item]="item" *ngIf="isCard()"></card-result-item>
<subject-result-item [item]="item" *ngIf="isAutograph()"></subject-result-item>